import { Box, IconButton, useTheme } from "@outschool/backpack";
import {
  faFaceConfusedRegular,
  faFaceConfusedSolid,
  faFaceFrownRegular,
  faFaceFrownSolid,
  faFaceGrinHeartsRegular,
  faFaceGrinHeartsSolid,
  faFaceMehRegular,
  faFaceMehSolid,
  faFaceSmileRegular,
  faFaceSmileSolid
} from "@outschool/icons";
import React from "react";

type SmileyInputProps = {
  rating: number;
  setRating: (rating: number) => void;
};

export default function SmileyInput({ rating, setRating }: SmileyInputProps) {
  const theme = useTheme();

  const SMILEYS = [
    {
      rating: 1,
      unselected: faFaceFrownRegular,
      selected: faFaceFrownSolid,
      color: theme.palette.error[600]
    },
    {
      rating: 2,
      unselected: faFaceConfusedRegular,
      selected: faFaceConfusedSolid,
      color: theme.palette.error[500]
    },
    {
      rating: 3,
      unselected: faFaceMehRegular,
      selected: faFaceMehSolid,
      color: theme.palette.warning[500]
    },
    {
      rating: 4,
      unselected: faFaceSmileRegular,
      selected: faFaceSmileSolid,
      color: theme.palette.success[400]
    },
    {
      rating: 5,
      unselected: faFaceGrinHeartsRegular,
      selected: faFaceGrinHeartsSolid,
      color: theme.palette.success[500]
    }
  ];

  return (
    <Box
      flex
      sx={{
        flexDirection: "row",
        gap: "1em",
        paddingTop: "1em",
        paddingBottom: "1em"
      }}
    >
      {SMILEYS.map((smiley, index) => (
        <IconButton
          variant="text"
          key={index}
          icon={rating === smiley.rating ? smiley.selected : smiley.unselected}
          onClick={() => setRating(smiley.rating)}
          sx={{
            color: smiley.color,
            borderColor:
              rating === smiley.rating ? smiley.color : theme.palette.grey[50],
            fontSize: 32,
            "box-shadow": "0px 1px 8px 0px #0000000A",
            borderRadius: ".25em",
            padding: ".5em"
          }}
        />
      ))}
    </Box>
  );
}
